
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import * as echarts from "echarts";
import {
  Answer,
  Candidate,
  CandidateResult,
  MiddleInfo
} from "@/lib/model/exam/result";

export class EmotionData {
  emotionType = "";
  imgUrl = "";
}

@Component({})
export default class ExamResult extends Vue {
  $refs!: {
    echartsL: HTMLCanvasElement;
    echartsR: HTMLCanvasElement;
    echartTop: HTMLCanvasElement;
    result: HTMLFormElement;
    PCvideo: HTMLElement[];
  };
  //饼图用色
  colorList = [
    "#4CDE99",
    "#FDC151",
    "#33DFE4",
    "#8851FD",
    "#33B1FF",
    "#FF9245",
    "#FD5151",
    "#BDFD51",
    "#516AFD",
    "#B999D4",
    "#51FD84",
    "#FD51B8",
    "#FDFB51",
    "#51FDC5",
    "#E551FD"
  ];
  opacity = "red";
  //成绩
  infoList: any[] = [];
  //AI维度
  AIList: any[] = [];
  scoreTotal = 0; //总分
  scoreTotalAll = 0; //满分
  qIndex = -400;
  //Ec雷达配置
  optionRadar = {
    tooltip: {},
    radar: {
      shape: "circle",
      splitNumber: 5, //几段线
      nameGap: 5, //名称和轴的距离
      radius: "65%",
      splitArea: { areaStyle: { color: ["#FFFFFF"] } }, //背景区域
      splitLine: { lineStyle: { color: ["#EAEDF7"] } }, //极坐标
      axisLine: { lineStyle: { color: "#EAEDF7" } }, //轴线
      name: {
        textStyle: {
          fontSize: "9",
          fontWeight: 400,
          fontFamily: "PingFangSC-Regular",
          color: "#8590A6"
        }
      },
      indicator: [
        { name: "", max: 0 },
        { name: "", max: 0 },
        { name: "", max: 0 },
        { name: "", max: 0 },
        { name: "", max: 0 },
        { name: "", max: 0 }
      ]
    },
    series: [
      {
        name: "考察维度得分",
        type: "radar",
        symbol: "circle", //形状
        symbolSize: 2, // 拐点的大小
        itemStyle: {
          color: "#FF5FA6FF"
        },
        data: [
          {
            value: [0]
          }
        ],
        lineStyle: { color: "#FF5FA6FF", width: 1 },
        areaStyle: { color: "#FF5FA626", opacity: 0.15 }
      }
    ]
  };
  //Ec饼状图配置
  optionPie = {
    tooltip: {
      trigger: "item",
      formatter: "{b}：{d}%"
    },
    series: [
      {
        name: "考察维度权重",
        type: "pie",
        clockwise: false, //是否顺时针
        color: this.colorList,
        radius: ["35%", "60%"],
        label: {
          show: true,
          fontSize: 9,
          lineHeight: 12,
          color: "#8590A6",
          formatter: "{b}" + "\n" + "{d}%",
          position: "left"
        },
        itemStyle: { borderWidth: 1, borderColor: "#FFFFFF" },
        emphasis: {
          scaleSize: 2,
          focus: "self",
          //聚焦态
          label: {
            show: true,
            fontSize: "9px",
            fontWeight: "bold"
          }
        },
        labelLine: {
          show: false,
          length: 10, //两段线 控制文字位置
          length2: 0
        },
        data: [
          { value: 200, name: "A权重占比" },
          { value: 400, name: "B权重占比" },
          { value: 100, name: "C权重占比" },
          { value: 484, name: "D权重占比" },
          { value: 300, name: "E权重占比" },
          { value: 300, name: "F权重占比" }
        ]
      }
    ]
  };

  candidate = new Candidate(); //候选人信息 主表
  candidateResult = new CandidateResult(); //候选人信息 所有表
  connectCode = "";
  middleInfo = new MiddleInfo();
  showMS = false; //展示中位数数据
  mindData = new Answer();
  ed: any = {}; //examData
  showEc = true;

  // 答题用时
  get timeLong() {
    let t = 0;
    if (this.ed.handTime !== 0) {
      t = this.ed.handTime - this.ed.startTime;
    } else {
      t = this.ed.endTime - this.ed.startTime;
    }
    return t;
  }

  @Prop({
    type: Object || undefined,
    required: false
  })
  examData!: any; //题目所有信息
  @Prop({
    type: Boolean,
    default: false
  })
  showQuestion!: boolean;
  @Prop({
    type: Boolean,
    default: true
  })
  showInfo!: boolean;

  @Watch("examData")
  getData(n: any) {
    if (!n) return;
    this.ed = n;
    let qIndex = 1;
    this.ed.paperSections.forEach((d: any) => {
      d.questions.forEach((q: any) => {
        q.qIndex = qIndex;
        qIndex++;
      });
    });
    //确保Ec容器渲染完成
    this.$nextTick(() => {
      this.open();
    });
  }

  mounted() {
    //
  }

  //入口
  open() {
    if (this.showInfo) {
      this.setEcharts(); //EC
      this.setScore();
    }
    this.$nextTick(() => {
      this.listenVideo(); //视频监听
    });
  }

  //处理成绩
  setScore() {
    this.infoList = [
      {
        name: "得分",
        value: `${this.ed?.score}/${this.ed?.paperScore}`
      },
      {
        name: "用时",
        value: `${Math.floor(this.timeLong / 60)}分${Math.round(
          this.timeLong % 60
        )}秒`
      },

      { name: "作答设备", value: this.ed?.deviceType }
    ];
  }
  //选择题回答
  getHisAnswer(q: any) {
    if (!q) return;
    const answerList = q?.answerContent.split(",");
    const resList: string[] = [];
    q?.answers.forEach((d: any, i: number) => {
      answerList.forEach((m: any) => {
        if (d.id === m) resList.push(String.fromCharCode(65 + i));
      });
    });
    return resList.join(",");
  }
  //填空回答
  getTKanswer(t: any) {
    return t.split("@#^#@");
  }
  //Ec渲染
  setEcharts() {
    if (this.ed?.paperSections.length === 0) return;
    let questionTypeNum = 0;

    this.AIList = [];
    // this.scoreTotal = 0;
    // this.scoreTotalAll = 0;
    this.optionRadar.series[0].data[0].value = [];
    this.optionRadar.radar.indicator = [];
    this.optionPie.series[0].data = [];
    this.ed.paperSections.forEach((d: any, index: number) => {
      if (d.questions.length === 0) return;
      questionTypeNum++;
      // this.scoreTotal += d.score; // 总得分
      // this.scoreTotalAll += d.scoreAll; //总分
      let typeScoreAll = 0; //类型题总分
      let typeScore = 0; //类型题得分
      d.questions.forEach((m: any) => {
        typeScoreAll += m.score;
        typeScore += m.answerScore;
      });
      //雷达数据
      this.optionRadar.radar.indicator.push({
        name: d?.name + "\n" + `(${typeScore}/${typeScoreAll})`,
        max: typeScoreAll
      });
      this.optionRadar.series[0].data[0].value.push(
        typeScore > 0 ? typeScore : 0
      );
      //饼图数据
      this.optionPie.series[0].data.push({
        name: d?.name,
        value: typeScoreAll
      });
      const num =
        typeScoreAll === 0
          ? 0
          : Number.isInteger(typeScore / typeScoreAll)
          ? Number(typeScore / typeScoreAll)
          : Number((typeScore / typeScoreAll).toFixed(2)); //整数取整 小数取两位
      //表格数据
      this.AIList.push({
        name: d?.name,
        score: typeScore,
        scoreAll: typeScoreAll,
        precent: num * 100
      });
    });
    //数据少于两个维度 则不展示Ec
    if (questionTypeNum < 3) {
      this.showEc = false;
      return;
    }
    this.$nextTick(() => {
      //雷达
      const echartsL = echarts.init(this.$refs.echartsL);
      echartsL.setOption(this.optionRadar);
      //饼图
      const echartsR = echarts.init(this.$refs.echartsR);
      echartsR.setOption(this.optionPie);
    });
  }
  //自动暂停其他视频
  listenVideo() {
    const v: any = this.$refs.PCvideo;
    if (!v) return;
    v.forEach((video: any) => {
      video.addEventListener("play", (d: any) => {
        v.forEach((item: any) => {
          if (d.currentTarget.id !== item.id) {
            item.pause();
          }
        });
      });
    });
  }
}
